import "./LoadingSpinner.css";

/**
 * Shown while the sign-in check runs and while a page's code loads. A ring
 * drawn in CSS with the brand orange: it replaced images/loading.gif, a 1 MB
 * animation that was the heaviest thing on every first visit.
 */
function LoadingSpinner({ label = "Loading, please wait..." }) {
  return (
    <div className="app-loading" role="status" aria-live="polite">
      <span className="app-loading__ring" aria-hidden="true" />
      <p>{label}</p>
    </div>
  );
}

export default LoadingSpinner;
